import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts(
  'profile',
  'delete-user-outcome-attachment',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'todo',
  type: 'delete',
  slug: [
    'outcome_attachments',
    {
      type: 'payload.query',
      queryParameter: 'id',
      selector: 'id',
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/delete-user-outcome-attachment.js